import React from 'react';
import c from 'classnames';

import Button from '../Button';

const FormattedLink = ({ link }) => {
  if (link === undefined || link.size <= 0) return null;

  const regExp = /button--(\w+)/i;

  return (
    <div className={c('u-multiple-buttons', 'u-multiple-buttons--horizontal', 'u-margin--top--6')}>
      {link.map((field) => {
        const linkClass = field.getIn(['options', 'attributes', 'class']);
        const type = regExp.test(linkClass) ? regExp.exec(linkClass)[1] : 'link';

        return (
          <Button
            type={type}
            key={`link:${field.get('title')}`}
            href={field.get('alias') ? field.get('alias') : field.get('uri')}
          >
            {field.get('title')}
          </Button>
        );
      })}
    </div>
  );
};

export default FormattedLink;
